<template>
  <div class="stats">
    <template v-if="!isAssigned">
      <div class="stat-item" style="flex: 2;">
        <el-button
            @click="onAssignHomework"
            type="primary"
            :class="{ 'flash-animation': shouldFlash }"
            style="width: 100%; height: 140px; font-size: 18px; font-weight: bold; border-radius: 15px; display: flex !important; flex-direction: column !important; align-items: center !important; justify-content: center !important;">
          <div style="line-height: 1.5;">布 置</div>
          <div style="line-height: 1.5;">作 业</div>
        </el-button>
      </div>
    </template>
    <template v-else>
      <div class="stat-item">
        <div class="stat-number finished">{{ finishedCount }}</div>
        <div>已订正</div>
      </div>
      <div class="stat-item">
        <div class="stat-number unfinished">{{ unfinishedCount }}</div>
        <div>未订正</div>
      </div>
    </template>
    <div class="stat-item">
      <el-button
          @click="onSwitchSubject"
          class="subject-toggle-btn"
          :class="subjectClass"
          style="width: 100%; height: 70px; font-size: 18px; font-weight: bold; border-radius: 15px; color: white; display: flex; align-items: center; justify-content: center;">
        {{ currentSubject }}
      </el-button>
    </div>
    <div class="stat-item">
      <el-button
          @click="onToggleUnfinishedCount"
          :class="{'unfinished-count-btn': true, 'active': showUnfinishedCount}"
          style="width: 100%; height: 70px; font-size: 18px; font-weight: bold; border-radius: 15px; display: flex; align-items: center; justify-content: center;">
        欠交数量
      </el-button>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/EventBus'

export default {
  name: 'StatisticsPanel',
  props: {
    currentDate: {
      type: String,
      default: ''
    },
    selectedType: {
      type: Number,
      default: 1
    },
    classId: {
      type: Number,
      default: null
    },
    currentSubject: {
      type: String,
      default: '语文'
    },
    subjectClass: {
      type: String,
      default: 'chinese-subject'
    },
    showUnfinishedCount: {
      type: Boolean,
      default: false
    },
    isAssigned: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localFinishedCount: 0,
      localUnfinishedCount: 0,
      shouldFlash: false,
      // 防止重复调用的标识
      isUpdatingStats: false,
      // 延迟执行的定时器
      pendingUpdate: null
    }
  },
  computed: {
    finishedCount() {
      return this.localFinishedCount;
    },
    unfinishedCount() {
      return this.localUnfinishedCount;
    }
  },
  mounted() {
    // 组件挂载时初始化统计数据
    this.updateStats();
    
    // 监听布置作业按钮闪烁事件
    EventBus.$on('trigger-assign-homework-flash', this.triggerFlash);
    
    // 监听学生状态变化事件
    EventBus.$on('student-status-changed', this.handleStudentStatusChanged);
  },
  beforeDestroy() {
    // 移除事件监听器
    EventBus.$off('trigger-assign-homework-flash', this.triggerFlash);
    EventBus.$off('student-status-changed', this.handleStudentStatusChanged);
  },
  methods: {
    onSwitchSubject() {
      this.$emit('switch-subject')
    },
    onToggleUnfinishedCount() {
      this.$emit('toggle-unfinished-count')
    },
    onAssignHomework() {
      this.$emit('assign-homework')
    },
    
    // 触发布置作业按钮闪烁效果
    triggerFlash() {
      this.shouldFlash = true;
      setTimeout(() => {
        this.shouldFlash = false;
      }, 400);
    },
    
    // 处理学生状态变化事件
    handleStudentStatusChanged(payload) {
      this.updateStats();
      
      if (payload.showUnfinishedCount) {
        this.$emit('load-unfinished-counts');
      }
    },
    
    // 更新统计数据的方法（完全自包含）
    updateStats() {
      // 确保必要的参数都存在
      if (!this.currentDate || !this.selectedType) {
        return Promise.resolve();
      }
      
      // 检查是否正在更新中，如果是则取消之前的请求并重新开始
      if (this.isUpdatingStats) {
        // 取消之前的请求（如果有的话）
        if (this.currentRequestSource) {
          this.currentRequestSource.cancel('新请求取代旧请求');
        }
      }
      
      // 设置更新状态
      this.isUpdatingStats = true;
      
      // 创建新的取消令牌
      const CancelToken = this.$http.CancelToken;
      this.currentRequestSource = CancelToken.source();
      
      let url = `/correctionRecords/statistics?date=${this.currentDate}&typeId=${this.selectedType}`
      if (this.classId) {
        url = `/correctionRecords/statistics?date=${this.currentDate}&typeId=${this.selectedType}&classId=${this.classId}`
      }

      // 创建新的请求并返回Promise
      return this.$http.get(url, {
        cancelToken: this.currentRequestSource.token
      })
          .then(response => {
            // 统一处理默认值，确保不会出现 undefined
            this.localFinishedCount = response.data.finished || 0
            this.localUnfinishedCount = response.data.unfinished || 0
          })
          .catch(error => {
            // 检查是否是取消请求的错误
            if (this.$http.isCancel(error)) {
              return;
            }
            
            console.error('[StatisticsPanel] 接口请求失败:', error)
            // 出错时设置默认值
            this.localFinishedCount = 0;
            this.localUnfinishedCount = 0;
          })
          .finally(() => {
            // 重置更新状态
            this.isUpdatingStats = false;
            this.currentRequestSource = null;
          })
    }
  }
}
</script>